import { Worksite } from "@wingspanhq/wingspan-api-sdk";

import { FormDataWorksite } from "../types";

/**
 * Seeds the work site form. Called with no work site for the create flow, so
 * every field falls back to the empty value the inputs expect (`null` for the
 * state select, `""` for text inputs).
 */
export const selectorWorksiteFormDefaultValues = (
  worksite?: Worksite
): FormDataWorksite => ({
  name: worksite?.name || "",
  address: {
    addressLine1: worksite?.address?.line1 || "",
    addressLine2: worksite?.address?.line2 || "",
    city: worksite?.address?.city || "",
    state: worksite?.address?.state || null,
    postalCode: worksite?.address?.postalCode || ""
  },
  externalId: worksite?.externalId || "",
  isPrimary: !!worksite?.isPrimary
});
